
import { SalesConciergeRequest } from '../models/sales-concierge-request.model';
import {HttpServiceBase} from '../../../../../../core/services/http-service-base';

export abstract class ISalesConciergeHttpService extends HttpServiceBase{
    public abstract createSalesConciergeRequest( salesConciergeRequest: SalesConciergeRequest ): Promise<void>;
}

